var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSealed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.8012,
    height: 37.8012,
    rx: 18.9006,
    fill: "#E86A0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2635 10.4207C20.2635 10.0894 19.9925 9.81836 19.6612 9.81836H17.1805C16.8492 9.81836 16.5781 10.0894 16.5781 10.4207V11.9792H20.2635V10.4207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0701 12.8827H14.7668C14.2699 12.8827 13.8633 13.2893 13.8633 13.7862V26.2248C13.8633 26.7217 14.2699 27.1283 14.7668 27.1283H22.0701C22.5671 27.1283 22.9736 26.7217 22.9736 26.2248V13.7862C22.9736 13.2893 22.5671 12.8827 22.0701 12.8827ZM18.4185 22.992C16.769 22.992 15.4318 21.6551 15.4318 20.0056C15.4318 18.3561 16.769 17.0189 18.4185 17.0189C20.068 17.0189 21.4051 18.3561 21.4051 20.0056C21.4051 21.6551 20.068 22.992 18.4185 22.992Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0211 17.7803H17.8164V20.6414H20.6775V19.4367H19.0211V17.7803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSealed);
export default __webpack_public_path__ + "static/media/sealed.9d5a44cecd29b7b49b33269acd808359.svg";
export { ForwardRef as ReactComponent };